import { lazy } from 'react'
import type { RouteWithMeta } from '../types'
import { withSuspense } from '../utils/withSuspense'

// Lazy loading으로 성능 최적화
const BannerPage = lazy(() => import('@/pages/screen/banner/page'))
const BannerAddPage = lazy(() => import('@/pages/screen/banner/BannerAddPage'))
const BannerHomeDetailPage = lazy(() => import('@/pages/screen/banner/BannerDetailPage'))
const BannerArtistDetailPage = lazy(() => import('@/pages/screen/banner/BannerArtistDetailPage'))
const CuratorPage = lazy(() => import('@/pages/screen/curator/CuratorPage'))
const CuratorAddPage = lazy(() => import('@/pages/screen/curator/CuratorAddPage'))
const CuratorDetailPage = lazy(() => import('@/pages/screen/curator/CuratorDetailPage'))
const PopupPage = lazy(() => import('@/pages/screen/popup/page'))
const PopupAddPage = lazy(() => import('@/pages/screen/popup/PopupAddPage'))
const PopupDetailPage = lazy(() => import('@/pages/screen/popup/PopupDetailPage'))

/**
 * 콘텐츠 관리 라우트
 * - 메인 영역(배너/ 홈, 아티스트 ,앨범)
 * - 섹션 관리
 * - 팝업
 */
export const screenRoutes: RouteWithMeta = {
  path: 'screen',
  meta: {
    label: '화면',
    showInMenu: true,
    icon: ''
  },
  children: [
    // ===== 메인 영역 =====
    {
      path: 'banner',
      element: withSuspense(<BannerPage/>),
      meta: {
        label: '메인 영역',
        showInMenu: true,
      }
    },
    {
      path: 'banner/:bannerId/add',
      element: withSuspense(<BannerAddPage category="home" />),
      meta: {
        label: '메인 영역 등록',
        showInMenu: false,
      }
    },
    {
      path: 'banner/quiz/:bannerId/add',
      element: withSuspense(<BannerAddPage category="artist" />),
      meta: {
        label: '메인 영역 등록',
        showInMenu: false,
      }
    },
    {
      path: 'banner/album/:bannerId/add',
      element: withSuspense(<BannerAddPage category="album" />),
      meta: {
        label: '메인 영역 등록',
        showInMenu: false,
      }
    },
    {
      path: 'banner/:heroId/items/:itemId',
      element: withSuspense(<BannerHomeDetailPage/>),
      meta: {
        label: '메인 영역 상세',
        showInMenu: false
      }
    },
    {
      path: 'banner/quiz/:heroId/items/:itemId',
      element: withSuspense(<BannerArtistDetailPage/>),
      meta: {
        label: '메인 영역 상세',
        showInMenu: false,
      }
    },

    // ===== 섹션 관리 =====
    {
      path: 'curator',
      element: withSuspense(<CuratorPage/>),
      meta: {
        label: '섹션 관리',
        showInMenu: true,
      }
    },
    {
      path: 'curator/add',
      element: withSuspense(<CuratorAddPage/>),
      meta: {
        label: '섹션 등록',
        showInMenu: false
      }
    },
    {
      path: 'curator/:id',
      element: withSuspense(<CuratorDetailPage/>),
      meta: {
        label: '섹션 상세',
        showInMenu: false
      }
    },
    // ===== 팝업 =====
    {
      path: 'popup',
      element: withSuspense(<PopupPage/>),
      meta: {
        label: '팝업',
        showInMenu: true,
      }
    },
    {
      path: 'popup/add',
      element: withSuspense(<PopupAddPage/>),
      meta: {
        label: '팝업 등록',
        showInMenu: false
      }
    },
    {
      path: 'popup/:id',
      element: withSuspense(<PopupDetailPage/>),
      meta: {
        label: '팝업 상세',
        showInMenu: false
      }
    },
  ]
}